module.exports = __webpack_public_path__ + "static/media/item-row-gold.2d0ea1d0.png";